module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ack-title"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("o book is the work of one person alone. This book certainly is not and that is why I must thank the following for their assistance and generosity: without them it would be a much diminished work. Thanks to, in no particular order, Mark Sessions and W. K. Sessions for permission to use images published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tukes of York")]), _vm._v(": Nicholas Melia at the Borthwick Institute for Archives, University of York, for the Joseph Rowntree Foundation photographs and allowing access to numerous other primary sources; Raoul Guise and his excellent website; Dr Catherine Oakley, executive secretary at The Rowntree Society; Michael and Ian Collinson for permission to quote from the Pavement shop ledger book; Laura Yeoman, archivist (access and engagement) at Explore York Libraries and Archives, York Explore Library Learning Centre. Thanks too to John Lazenby, grandson of Percy Lazenby, for filling a gap in our industrial history which few knew even existed when he provided information on the elusive Lazenby & Son (York) Ltd. I am also grateful to Sue Major, John Stevens and Mavis Morris of Clements Hall Historical Society for permission to use their research on York Confectionery Company and H. Backhouse & Co.")]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bd1f37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgements.vue
// module id = 75
// module chunks = 0